import { lazy, Suspense, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../ui/Header";
import Footer from "../ui/Footer";
import i18n from "../utils/i18n";
import AOS from "aos";

const RequestServiceModal = lazy(() => import("../ui/RequestServiceModal"));

export default function RootLayout() {
  const [isSticky, setIsSticky] = useState();
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
  const lang = useSelector((state) => state.language.lang);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 118) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    localStorage.setItem("lang", lang);
    const body = document.querySelector("body");
    const html = document.querySelector("html");

    if (lang === "en") {
      body.classList.add("en");
      body.classList.remove("ar");
      html.setAttribute("dir", "ltr");
      html.setAttribute("lang", "en");
    } else {
      body.classList.remove("en");
      body.classList.add("ar");
      html.setAttribute("dir", "rtl");
      html.setAttribute("lang", "ar");
    }

    i18n.changeLanguage(lang);
  }, [lang]);

  useEffect(() => {
    AOS.init({
      offset: 40,
      delay: 0,
      duration: 350,
      easing: "ease-out-cubic",
      once: true,
      disable: () => window.matchMedia("(prefers-reduced-motion: reduce)").matches,
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    const frame = window.requestAnimationFrame(() => AOS.refreshHard());

    if (location.hash) {
      const hashTimer = window.setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
      return () => {
        window.cancelAnimationFrame(frame);
        window.clearTimeout(hashTimer);
      };
    }

    return () => window.cancelAnimationFrame(frame);
  }, [location]);

  return (
    <>
      <header className={`${isSticky === true ? "sticky" : ""}`}>
        <Header />
      </header>
      <main className={`${isSticky === true ? "main_fixed" : ""}`}>
        <Outlet />
      </main>
      <Footer />
      <button className="floating_btn" onClick={() => setShowModal(true)}>
        <img src="/images/support.svg" alt="support" />
      </button>
      {showModal && (
        <Suspense fallback={null}>
          <RequestServiceModal show={showModal} setShow={setShowModal} />
        </Suspense>
      )}
    </>
  );
}
